import { Pipe, PipeTransform } from '@angular/core';

import { PlatformCatalog } from '@mp/content-manager/plattformkataloge/data-access';

import { PlatformCatalogCountInfo } from './platformcatalog-panel/platformcatalog-panel.component';

@Pipe({ name: 'mpPlatformCatalogCountInfo' })
export class PlatformCatalogCountInfoPipe implements PipeTransform {
  transform(platformCatalog: PlatformCatalog): PlatformCatalogCountInfo {
    return {
      industryCatalogs: platformCatalog.catalogsTotalCount,
      organizations: platformCatalog.assignedOrganizationsCount,
      articles: platformCatalog.articlesTotalCount,
    };
  }
}
